import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
});

export const buildCheckoutQuery = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.from) params.set("from", filters.from);
  if (filters.to) params.set("to", filters.to);
  if (filters.status && filters.status !== "all") params.set("status", filters.status);
  if (filters.search) params.set("search", filters.search);
  if (filters.coupon && filters.coupon !== "all") params.set("coupon", filters.coupon);
  if (filters.couponCode) params.set("couponCode", filters.couponCode);
  if (filters.payment && filters.payment !== "all") params.set("payment", filters.payment);
  if (filters.hasWishlist) params.set("hasWishlist", "true");
  if (filters.hasCart) params.set("hasCart", "true");
  if (filters.reachedCheckout === false) params.set("reachedCheckout", "false");
  if (filters.placedOrder) params.set("placedOrder", "true");
  if (filters.page) params.set("page", String(filters.page));
  if (filters.pageSize) params.set("pageSize", String(filters.pageSize));
  if (filters.sort) params.set("sort", filters.sort);
  if (filters.sortDir) params.set("sortDir", filters.sortDir);
  if (filters.abandonMinutes) params.set("abandonMinutes", String(filters.abandonMinutes));
  if (filters.contact) params.set("contact", filters.contact);
  if (filters.orderStatus && filters.orderStatus !== "all") params.set("orderStatus", filters.orderStatus);
  if (filters.minAmount) params.set("minAmount", String(filters.minAmount));
  if (filters.channel && filters.channel !== "all") params.set("channel", filters.channel);
  if (filters.trafficKind && filters.trafficKind !== "all") params.set("trafficKind", filters.trafficKind);
  if (filters.campaign) params.set("campaign", filters.campaign);
  if (filters.medium) params.set("medium", filters.medium);
  if (filters.attributed && filters.attributed !== "all") params.set("attributed", filters.attributed);
  return params.toString();
};

const readError = async (response, fallback) => {
  try {
    const data = await response.json();
    return data.message || fallback;
  } catch {
    return fallback;
  }
};

export const fetchCustomerCheckouts = async (filters) => {
  const qs = buildCheckoutQuery(filters);
  const response = await fetch(`${API_BASE_URL}/VisitorTracking/checkouts?${qs}`, {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(await readError(response, "تعذر تحميل بيانات العملاء"));
  return response.json();
};

export const fetchCustomerCheckout = async (sessionId, abandonMinutes) => {
  const params = new URLSearchParams();
  if (abandonMinutes) params.set("abandonMinutes", String(abandonMinutes));
  const response = await fetch(`${API_BASE_URL}/VisitorTracking/checkouts/${sessionId}?${params}`, {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(await readError(response, "تعذر تحميل تفاصيل العميل"));
  return response.json();
};

export const fetchCheckoutCouponCodes = async (search) => {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  const response = await fetch(`${API_BASE_URL}/VisitorTracking/checkouts/coupon-codes?${params}`, {
    headers: authHeaders(),
  });
  if (!response.ok) return [];
  return response.json();
};

export const exportCustomerCheckouts = async (filters) => {
  const qs = buildCheckoutQuery(filters);
  const response = await fetch(`${API_BASE_URL}/VisitorTracking/checkouts/export?${qs}`, {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error(await readError(response, "تعذر تصدير البيانات"));
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "customer-checkouts.csv";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
